import React from "react";

export default function QuotationSectionOneHeader({ helper, actions = null }) {
  return (
    <header className="flex flex-wrap items-center justify-between gap-3 p-4" data-testid="quotation-section-one-header">
      <div>
        <h2 className="text-lg font-semibold">1. Service Item</h2>
        {helper ? <p className="mt-1 text-xs text-muted-foreground">{helper}</p> : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </header>
  );
}
